export function downloadFile(blob: Blob, fileName: string): void {
  const downloadLink = document.createElement('a');
  const blobUrl = window.URL.createObjectURL(blob);
  downloadLink.href = blobUrl;
  downloadLink.setAttribute('download', fileName);
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  window.URL.revokeObjectURL(blobUrl);
}
